<template>
  <el-table
    :data="tableData"
    border
    class="w-full"
    height="280px"
    stripe
    ref="tableRef"
    :span-method="spanMethod"
  >
    <el-table-column label="节点时间" prop="time" width="130" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{ scope.row.time | showText('time') }}</span>
      </template>
    </el-table-column>
    <el-table-column label="关联题目" prop="serialNumber">
      <template slot-scope="scope">
        <div class="flex justify-between items-center " v-show="scope.row.topic">
          <div class="flex-1">
            <question-content-view
              :row="scope.row"
              :index="scope.$index"
              :pageConfig="pageConfig"
            ></question-content-view>
          </div>
          <el-button
            class="w-100px"
            size="mini"
            type="danger"
            v-if="!disabled"
            @click="$emit('removeTopic', scope.$index)"
            >清除试题</el-button
          >
        </div>
      </template>
    </el-table-column>
    <el-table-column label="操作" width="220" fixed="right">
      <template slot-scope="scope">
        <el-button @click="$emit('linkTopic', scope.row.time)" size="mini" :disabled="disabled"
          >关联题目</el-button
        >
        <el-button @click="$emit('clearNode', scope.row.time)" size="mini" :disabled="disabled"
          >清除节点</el-button
        ></template
      >
    </el-table-column>
  </el-table>
</template>

<script>
import QuestionContentView from '../QuestionContentView'
import { formatSeconds } from '../EnumField'

export default {
  name: 'train-table-com',
  components: { QuestionContentView },
  filters: {
    showText: (val, type) => {
      let result = ''
      if (type === 'time') {
        result = formatSeconds(val)
      }
      return result
    },
  },
  props: {
    tableData: {
      typeof: Array,
      default: () => {
        return []
      },
    },
    disabled: {
      typeof: Boolean,
      default: false,
    },
  },
  data() {
    return {
      position: 0,
      spanArrObj: {},
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  watch: {
    'tableData.length': {
      handler() {
        this.getSpanArr()
        this.$nextTick(() => {
          this.$refs.tableRef.doLayout()
        })
      },
      immediate: true,
    },
  },
  computed: {},
  created() {},
  methods: {
    getSpanArr() {
      this.position = 0
      this.spanArrObj = {}
      const needSpan = ['time']
      needSpan.forEach((item) => {
        this.rowspan(item)
      })
    },
    // 获取合并行参数(数组)
    rowspan(prop) {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          if (!this.spanArrObj[prop]) {
            this.spanArrObj[prop] = []
          }
          this.spanArrObj[prop].push(1)
          this.position = 0
        } else if (this.tableData[index][prop] === this.tableData[index - 1][prop]) {
          this.spanArrObj[prop][this.position] += 1
          this.spanArrObj[prop].push(0)
        } else {
          if (!this.spanArrObj[prop]) {
            this.spanArrObj[prop] = []
          }
          this.spanArrObj[prop].push(1)
          this.position = index
        }
      })
    },
    // 合并行方法
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if ([0, 2].includes(columnIndex)) {
        const _row = this.spanArrObj.time[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col,
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }
    },
  },
}
</script>

<style></style>
